import {AlertIcon} from '@primer/octicons-react'
import {SkeletonAvatar, SkeletonText} from '@primer/react/experimental'
import {ForYouLeadingIcon} from './ForYouLeadingIcon'
import {ForYouItem} from './ForYouItem'

/**
 * Skeleton placeholder rendered while a ForYouItem's async content loads.
 * Mirrors the collapsed-header shape of ForYouItem so the layout is stable.
 */
export function ForYouItemSkeleton() {
  return (
    <ForYouItem
      ariaLabel="Loading item"
      itemName="Loading item"
      leadingVisual={<SkeletonAvatar size={16} />}
      title={<SkeletonText size="bodyMedium" />}
      busy
      sectionVisibilityKind="loading-item"
    />
  )
}

/**
 * Error state rendered when a ForYouItem's content throws.
 * Matches the collapsed-header shape so the list layout is preserved.
 */
export function ForYouItemError() {
  return (
    <ForYouItem
      itemName="Error item"
      leadingVisual={<ForYouLeadingIcon icon={AlertIcon} variant="danger" />}
      title="Unable to load this item"
      description="Try reloading the page."
    />
  )
}
